export default {"src":"/_next/static/media/client_centered_excellence.7814cf3f.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};